import { Box, Stack, Typography, Grid } from "@mui/material";
import { icons, images } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => {
  return [
    {
      head: t("admin_profile.admin_image"),
      icon: icons?.media,
      details: [
        {
          name: (
            <Grid
              Grid
              item
              xs={12}
              sx={{
                border: " 1px solid rgba(0, 0, 0, 0.25)",
                borderRadius: "10px",
                position: "relative",
                minHeight: "200px",
              }}
              onDragOver={(e) => e.preventDefault()}
            >
              <Stack
                justifyContent="center"
                alignItems="center"
                // height='100%'
                minHeight="214px" // Set a fixed height for the stack
              >
                <Box
                  component="img"
                  src={data?.avatar || data?.logo}
                  alt={t("admin_profile.image")}
                  width={"30%"}
                  height={"100%"}
                  maxHeight="214px"
                  sx={{
                    borderRadius: "10px",
                  }}
                />
              </Stack>
            </Grid>
          ),
        },
      ],
    },
    {
      head: t("admin_profile.admin_details"),
      icon: icons?.detailsIcon,
      details: [
        {
          label: t("admin_profile.name"),
          name: data?.name,
        },
        {
          label: t("admin_profile.role"),
          name: data?.role?.name,
        },
        {
          label: t("admin_profile.phone"),
          name: data?.phone_number,
        },
        {
          label: t("admin_profile.email"),
          name: data?.email,
        },
      ],
    },
    {
      head: t("admin_profile.dates"),
      icon: icons.dates,
      details: [
        {
          label: t("admin_profile.created_at"),
          name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
        },
        {
          label: t("admin_profile.updated_at"),
          name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
        },
        {
          label: t("admin_profile.last_sign_in_at"),
          name: dayjs(data?.last_sign_in).format("DD-MM-YYYY HH:MM a"),
        },
      ],
    },
  ];
};
